import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-dark.png'


const _hoisted_1 = { class: "flex h-20 items-center justify-between rounded-t-md bg-[#143151] px-4 py-2 text-white" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "size-14"
}, null, -1)
const _hoisted_6 = { class: "text-xl font-semibold" }

import {
  PhCornersIn,
  PhList,
  PhMinus,
} from '@phosphor-icons/vue';
import {
  computed,
} from 'vue';
import SupportMenuList from '@/components/ChatTitle/SupportMenuList.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatTitle',
  emits: ["close"],
  setup(__props, { emit: __emit }) {


const emits = __emit;

const utilStore = useStore.util;
const isLeftNavigationMenuOn = computed(() => utilStore.isLeftNavigationMenuOn);

const isSupportDisabled = computed(() => !useStore.auth.userId || !useStore.auth.company);

const conversationHistoryStore = useStore.conversationHistory;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "tooltip",
        "data-tip": "Customer Support",
        disabled: isSupportDisabled.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(utilStore).isLeftNavigationMenuOn = !_unref(utilStore).isLeftNavigationMenuOn))
      }, [
        (isLeftNavigationMenuOn.value)
          ? (_openBlock(), _createBlock(_unref(PhCornersIn), {
              key: 0,
              class: "size-8 drop-shadow-2xl transition-all hover:text-red-500"
            }))
          : (_openBlock(), _createBlock(_unref(PhList), {
              key: 1,
              class: "size-8 drop-shadow-2xl transition-all hover:text-slate-300"
            }))
      ], 8, _hoisted_3),
      _createVNode(_Transition, {
        class: "absolute",
        name: "slide-down"
      }, {
        default: _withCtx(() => [
          (isLeftNavigationMenuOn.value)
            ? (_openBlock(), _createBlock(SupportMenuList, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(conversationHistoryStore).showHistoryList ? 'Chat History' : 'Chat Assistant'), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
    }, [
      _createVNode(_unref(PhMinus), {
        class: "hover:text-red-500",
        size: 32
      })
    ])
  ]))
}
}

})